import store from '../store'

export const loaddingHelper = {
  data () {
    return {
      changedData: false,
      watching: false
    }
  },
  methods: {
    toggleLoadding (loading = true) {
      store.dispatch('toggleLoadding', loading)
    }
  },
  metaInfo: {
    title: 'C.M.S - Hệ thống quản trị nội dung Goship',
    titleTemplate: '%s | goship.io'
  },
  watch: {
    changedData (value) {
      if (value) {
        window.onbeforeunload = (e) => {
          return false
        }
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.changedData) {
      this.$confirm('Dữ liệu bạn đã nhập chưa được lưu. Bạn chắc chắn muốn thoát trang?', 'Cảnh báo', {
        confirmButtonText: 'Thoát',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(() => {
        next()
      }).catch(() => {
        this.watching = true
      })
    } else {
      next()
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/index.js